// components/AOSInitializer.jsx
"use client";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function AOSInitializer() {
  useEffect(() => {
    AOS.init({
      once: true,
      disable: false,
      duration: 500,
      easing: "ease-out-cubic",
    });
  }, []);

  return null;
}
